<template>
  <banner
    :icon="!hideIcon ? 'fa-exclamation-triangle' : ''"
    :title="title"
    class="warning"
  >
    <slot></slot>
  </banner>
</template>
<script>
import Banner from "./Banner.vue";

export default {
  components: { Banner },
  props: {
    title: {
      type: String,
      required: false,
      default: "",
    },
    hideIcon: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>
<style lang="scss" scoped>
@use "sass:color";
@import "@/_css/variables";

.warning {
  border-color: $gold;
  color: $gold;
  background-color: color.adjust($gold, $lightness: 25%);
}
</style>
